import { ChevronDownIcon } from '@assets/icons';
import { Button } from '@components/button';
import { Group } from '@components/layout';
import { Box, Collapse, Stack, Typography } from '@mui/material';
import { PropsWithChildren, useState } from 'react';

export const KeysContainer = ({
  title,
  children,
  onCreate,
  count,
  collapsible = true,
  actionButtonLabel = 'Create',
}: PropsWithChildren<{
  title: string;
  onCreate?: () => void;
  count?: number;
  collapsible?: boolean;
  actionButtonLabel?: string;
}>) => {
  const [open, setOpen] = useState(true);
  return (
    <Stack gap={3}>
      <Group gap={2} alignItems="center" justifyContent="space-between">
        <Group
          alignItems="center"
          gap={3}
          onClick={() => setOpen(!open)}
          sx={{ cursor: 'pointer' }}
        >
          {collapsible && (
            <ChevronDownIcon
              style={{
                transition: 'all 0.2s',
                transform: !open ? 'rotate(0deg)' : 'rotate(180deg)',
              }}
            />
          )}
          <Typography variant="subtitle1" sx={{ color: 'text.default' }}>
            {title}
          </Typography>
          <Typography variant="subtitle1" sx={{ color: 'text.default' }}>
            {count !== null ? `(${count})` : '-'}
          </Typography>
        </Group>
        {onCreate && (
          <Button variant="accent" onClick={onCreate}>
            {actionButtonLabel}
          </Button>
        )}
      </Group>
      {collapsible ? (
        <Collapse in={open}>
          <Box sx={{ p: 4, backgroundColor: 'background.paper', overflow: 'auto' }}>{children}</Box>
        </Collapse>
      ) : (
        <Box sx={{ p: 4, backgroundColor: 'background.paper', overflow: 'auto' }}>{children}</Box>
      )}
    </Stack>
  );
};
